// extracted by mini-css-extract-plugin
export var brand = "_6v-9";
export var compact = "_6v-6";
export var extraSmall = "_6v-7";
export var icon = "_6v-0";
export var large = "_6v-4";
export var light = "_6v-1";
export var medium = "_6v-5";
export var outline = "_6v-b";
export var primaryDark = "_6v-a";
export var primaryLight = "_6v-8";
export var primaryModern = "_6v-c";
export var success = "_6v-2";
export var successSolid = "_6v-3";